import { Container } from '@components/layout/grid'
import ExclusiveOffer from '@components/onboarding/earlypay/exclusive-offer'
import type { PageWithContext } from '@lib/utils/context'
import { getOnboardingLayout } from '@page-templates/onboarding-page'

export const OnboardingPage: PageWithContext = () => {
    return (
        <Container>
            <ExclusiveOffer />
        </Container>
    )
}

OnboardingPage.getLayout = getOnboardingLayout()

export default OnboardingPage
